// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --COLOR_BLACK: #000;
  --COLOR_WHITE: #fff;
  --COLOR_DEFAULT: #f2f2f2;
  --COLOR_PRIMARY: #3d7c54;
  --COLOR_SECONDARY: #9ec9b6;
  --COLOR_TERTIARY: #e6f5ee;
  --COLOR_GRAY_LIGHT: #f2f2f2;
  --COLOR_GRAY_MEDIUM: #b2b2b2;
  --COLOR_GRAY_DARK: #1a1e22;
  --COLOR_ERROR: #ffe8e6;
}

/*# sourceMappingURL=sage.css.map */
`, "",{"version":3,"sources":["webpack://./../../libs/shared-fe/styles/themes/_common.scss","webpack://./../../libs/shared-fe/styles/themes/sage.scss","webpack://./../borrower-portal-ui/src/styles/dist/themes/sage.css"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,mBAAA;ECEF,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,sBAAA;ACTF;;AAaA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
